import { render, staticRenderFns } from "./querymarketer.vue?vue&type=template&id=f5837d38"
import script from "./querymarketer.vue?vue&type=script&lang=js"
export * from "./querymarketer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports